import React from 'react'
import { useHistory } from 'react-router-dom'
import { ErrorPageLayout, Button } from 'react-angle-dashboard-components'
import { Layout } from '../../layout/Layout'
import { Paths } from '../../routes/paths'

const NavButton: React.FC = ({ children }) => {
  const history = useHistory()
  return <Button onClick={() => history.push(Paths.home)}>{children}</Button>
}

export const NotFound = () => {
  return (
    <Layout showUserDropdown>
      <div>
        <ErrorPageLayout
          errorTitle="404 - Page not found"
          errorSubtitle="The page you were looking for could not be found."
          button={<NavButton>Go to home page</NavButton>}
        />
      </div>
    </Layout>
  )
}

export default NotFound
